/* eslint-disable import/no-default-export */
import { createRoot } from 'react-dom/client';
export default function makeOfferLauncher(options = {}) {
    const modalContainer = document.createElement('div');
    const {
        currency,
        itemId,
        selectedSkuId,
        environment,
        quantitySelected,
        shouldNotSendOfferMessage,
        launchOrigin,
        shouldLaunchContactDealer,
        gaLabel,
        page,
    } = options;
    return import(
        /* webpackChunkName: "makeOfferModal" */
        '../src/MakeOfferModal/makeOfferAsyncImports'
    ).then(mod => {
        const { components, helpers } = mod;

        const { MakeOfferModal, IntlProvider } = components;
        const { serverVars } = helpers;
        const root = createRoot(modalContainer, { identifierPrefix: 'offerModal' });

        root.render(
            <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
                <MakeOfferModal
                    launchOrigin={launchOrigin}
                    environment={environment}
                    itemId={itemId}
                    selectedSkuId={selectedSkuId}
                    pageCurrency={currency}
                    quantitySelected={quantitySelected}
                    shouldNotSendOfferMessage={shouldNotSendOfferMessage}
                    shouldLaunchContactDealer={shouldLaunchContactDealer}
                    gaLabel={gaLabel}
                    page={page}
                />
            </IntlProvider>
        );
    });
}
